<template>
  <div class="custom-tabs">
    <div class="tabs">
      <template v-for="tab in tabs">
        <input
          :key="'i-' + tab.key"
          type="radio"
          :id="'tab-' + tab.key"
          :value="tab.key"
          v-model="localValue"
        />
        <label :key="'l-' + tab.key" class="tab" :for="'tab-' + tab.key">
          <v-icon small>{{ tab.icon }}</v-icon>
          <span class="tab-label">{{ tab.label }}</span>
        </label>
      </template>

      <span class="glider" :style="gliderStyle"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingsTabs",
  props: {
    value: { type: Number, default: 0 }, // Vue2 v-model
    tabs: { type: Array, required: true },
    primary: { type: String, default: "#009F63" },
  },
  data() {
    return {
      tabWidths: [],
      gliderWidth: 0,
      gliderLeft: 0,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },

    activeIndex() {
      const idx = this.tabs.findIndex((t) => t.key === this.localValue);
      return idx >= 0 ? idx : 0;
    },

    gliderStyle() {
      return {
        transform: `translateX(${this.gliderLeft}px)`,
        backgroundColor: this.primary,
        width: `${this.gliderWidth}px`,
      };
    },
  },
  watch: {
    activeIndex: {
      handler() {
        this.$nextTick(() => {
          this.updateGlider();
        });
      },
      immediate: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.updateGlider();
    });
    window.addEventListener('resize', this.updateGlider);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateGlider);
  },
  methods: {
    updateGlider() {
      const tabsContainer = this.$el?.querySelector('.tabs');
      if (!tabsContainer) return;

      const labels = tabsContainer.querySelectorAll('.tab');
      if (!labels || labels.length === 0) return;

      const activeLabel = labels[this.activeIndex];
      if (!activeLabel) return;

      this.gliderWidth = activeLabel.offsetWidth;
      this.gliderLeft = activeLabel.offsetLeft;
    },
  },
};
</script>

<style lang="scss">
.custom-tabs {
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  justify-content: flex-start;

  .tabs {
    display: flex;
    position: relative;
    background-color: var(--v-lightGray-base);
    border-radius: 10px;
    width: fit-content;
    overflow: hidden;

    * {
      z-index: 2;
    }

    input[type="radio"] {
      display: none;

      // &:checked + label {
      //   color: black !important;

      //   .v-icon {
      //     color: white !important;
      //   }
      // }
    }

    .tab {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      height: 38px;
      font-size: 14px;
      font-weight: 600;
      color: var(--v-mainBlack-base);
      border-radius: 10px;
      cursor: pointer;
      transition: color 0.15s ease-in;
      font-family: "Avenir", sans-serif;
      padding: 0 16px;

      .v-icon {
        margin-right: 8px;
        font-size: 14px;
        color: var(--v-mainBlack-base);
        transition: color 0.15s ease-in;
      }

      .tab-label {
        white-space: nowrap;
      }
    }

    // .glider {
    //   position: absolute;
    //   display: flex;
    //   height: 38px;
    //   background-color: var(--v-mainGreen-base);
    //   border-radius: 10px;
    //   z-index: 1;
    //   transition: 0.25s ease-out;
    // }
    .glider {
      position: absolute;
      top: 0;
      left: 0;
      height: 38px;
      border-radius: 10px;
      z-index: 1;
      transition: 0.25s ease-out;
    }
  }
}
</style>
